import React from 'react'
import SpecialOffersControls from './SpecialOffersControls';
import SpecialOffersSlider from './SpecialOffersSlider';
import { SliderProvider } from 'components/SliderContext';

const SpecialOffers = ({list}) => {
  return (
    <SliderProvider>
      <section className="special-offers">
        <header className="special-offers__header">
          <h2 className="special-offers__title">Buy Packs <span>{list.length}</span> </h2>
          <SpecialOffersControls />
        </header>
        <SpecialOffersSlider list={list} />
      </section>
    </SliderProvider>
  )
}

export default SpecialOffers;
